import { EParkingType, NonEmptyArray } from '../types';

export const ALL_PARKING_TYPES: NonEmptyArray<EParkingType> = [
  EParkingType.Rooftop,
  EParkingType.Underground,
  EParkingType.Ground,
  EParkingType.Multilevel,
];
